
import AppModal from '../AppModal.vue'
import { addEvent } from '~/assets/js/gtm'

export default {
  name: 'DownloadPluginModal',
  components: {
    AppModal
  },

  emits: ['close'],

  methods: {
    trackDownload () {
      addEvent({ event: 'plugin.download' })
    }
  }
}
